// Basic
import PropTypes from 'prop-types';
import actionsPayluddSubscriptions from '../../api/actionsPayluddSubscriptions';
import getInitialQuery from '@/common-utils/components/renders/dataTable/utils/getInitialQuery';
import { columnsEmergencyContracts, columnsEmergencyContractsId } from './columnDef/columnsEmergencyContracts';
import DataTable from '@/common-utils/components/renders/dataTable/DataTable';

/**
 *
 * @param root0
 * @param root0.merchantAccountId
 * @param root0.singleSelection
 * @param root0.rowsSelected
 * @param root0.setRowsSelected
 * @param root0.posTerminalId
 * @param root0.filtersEventName
 * @returns {JSX} ContractsTable
 */
function EmergencyContractsTable({ posTerminalId, singleSelection = false, rowsSelected, setRowsSelected, filtersEventName }) {

    // Constants
    const initialQuery = getInitialQuery();
    const selectionMode = !!(rowsSelected && setRowsSelected);

    // Api Calls
    const { data, isLoading } = actionsPayluddSubscriptions.getEmergencyRemoteCollection({ posTerminalId });

    // Column definition
    const allColumns = columnsEmergencyContracts({
        query: initialQuery, setQuery: () => { },
        queryStored: initialQuery, storeQuery: () => { }, setLaunchRefetch: () => { },
        selectionMode,
        singleSelection,
        filtersEventName
    });

    // Render
    return (
        <DataTable
            filtersEventName={filtersEventName}
            columns={allColumns}
            data={data}
            dataFetchingIsLoading={isLoading}
            columnsId={columnsEmergencyContractsId}
            initialQuery={initialQuery}
            query={null}
            setQuery={() => { }}
            setLaunchRefetch={() => { }}

            selectionMode={selectionMode}
            singleSelection={singleSelection}
            rowsSelected={rowsSelected}
            setRowsSelected={setRowsSelected}
        />
    );
}

EmergencyContractsTable.propTypes = {
    posTerminalId: PropTypes.string.isRequired,
    singleSelection: PropTypes.bool,
    rowsSelected: PropTypes.object,
    setRowsSelected: PropTypes.func,
    filtersEventName: PropTypes.string
};

export default EmergencyContractsTable;